<template>
  <div class="kaineng">
    <div class="title animate__animated animate__fadeInUp">
      <titleCard title="Kang De Wei"></titleCard>
    </div>
    <div class="head-cards">
      <div class="card animate__animated wow animate__fadeInUp" data-wow-duration="0.8s">
        <div class="card-img">
          <div class="img"></div>
        </div>
        <p>24-Year History</p>
        <span></span>
      </div>
      <div class="card animate__animated wow animate__fadeInUp" data-wow-duration="1.2s">
        <div class="card-img">
          <div class="img img2"></div>
        </div>
        <p>30 Provinces Coverage</p>
        <span></span>
      </div>
      <div class="card animate__animated wow animate__fadeInUp" data-wow-duration="1.6s">
        <div class="card-img">
          <div class="img img3"></div>
        </div>
        <p>Over 35% Market Share</p>
        <span></span>
      </div>
      <div class="card animate__animated wow animate__fadeInUp" data-wow-duration="2.0s">
        <div class="card-img">
          <div class="img img4"></div>
        </div>
        <p>Higher Standard </p>
        <span></span>
      </div>
    </div>
    <!-- 公司简介 -->
    <div class="riref animate__animated wow animate__fadeInUp">
      <div class="left">
        <img class="img1" src="../../assets/image/Industry/kaineng1.webp" alt="">
      </div>
      <div class="right">
        <div class="logo">
          <img src="../../assets/image/Industry/kaineng3.webp" alt="">
        </div>
        <h3>Kaineng Kang De Wei Health & Technology (Beijing) Co, Ltd.</h3>
        <p>KDW, integrating scientific research, design and production and focusing on the development, sales and service of medical water treatment technology, hemodialysis technology and products, conducts its business in hundreds of hospitals and medical institutions in over 30 provinces and regions in China.</p>
        <div class="bg"></div>
      </div>
    </div>
    <div class="kaineng-bg animate__animated wow animate__fadeInUp">
      <p>Over 5,000 sets of products and services has been provided, <br>and it leads domestic dialysis water market.</p>
    </div>
    <!-- 工厂实拍 -->
    <div class="gongchang animate__animated wow animate__fadeInUp">
      <div class="title">
        <titleCard title="Factory Photos"></titleCard>
      </div>
      <div class="lunbo">
        <el-carousel arrow="never" trigger='click' :interval="5000">
          <el-carousel-item v-for="(item,index) in gongchangList" :key="index">
            <div class="pic pic1"><img :src="item.pic1" alt=""></div>
            <div class="pic pic2"><img :src="item.pic2" alt=""></div>
            <div class="pic pic3"><img :src="item.pic3" alt=""></div>
            <div class="pic pic4"><img :src="item.pic4" alt=""></div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="lunboios">
        <el-carousel arrow="never" trigger='click' :interval="4000">
          <el-carousel-item v-for="(item,index) in gongchangIOSList" :key="index">
            <div class="pic"><img :src="item.pic1" alt=""></div>
            <div class="pic"><img :src="item.pic2" alt=""></div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- 专利证书 -->
    <div class="zhuanli animate__animated wow animate__fadeInUp">
      <div class="title">
        <titleCard title="Certificates"></titleCard>
      </div>
      <div class="zhuanli-box">
        <el-carousel arrow="always" type="card" trigger='click' :autoplay='false'>
          <el-carousel-item v-for="(item,index) in fuwuList" :key="index">
            <img :src="item" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import titleCard from '@/components/title-card.vue'
export default {
  data() {
    return {
      fuwuList: [
        require('../../assets/image/Industry/lunbo2/1.webp'),
        require('../../assets/image/Industry/lunbo2/2.webp'),
        require('../../assets/image/Industry/lunbo2/3.webp'),
        require('../../assets/image/Industry/lunbo2/4.webp'),
        require('../../assets/image/Industry/lunbo2/5.webp'),
        require('../../assets/image/Industry/lunbo2/1.webp'),
      ],
      gongchangList: [{
        pic1: require('../../assets/image/Industry/lunbo/1.webp'),
        pic2: require('../../assets/image/Industry/lunbo/2.webp'),
        pic3: require('../../assets/image/Industry/lunbo/3.webp'),
        pic4: require('../../assets/image/Industry/lunbo/4.webp'),
      }, {
        pic1: require('../../assets/image/Industry/lunbo/4.webp'),
        pic2: require('../../assets/image/Industry/lunbo/5.webp'),
        pic3: require('../../assets/image/Industry/lunbo/6.webp'),
        pic4: require('../../assets/image/Industry/lunbo/1.webp'),
      }],
      gongchangIOSList: [{
        pic1: require('../../assets/image/Industry/lunbo/1.webp'),
        pic2: require('../../assets/image/Industry/lunbo/2.webp'),
      }, {
        pic1: require('../../assets/image/Industry/lunbo/3.webp'),
        pic2: require('../../assets/image/Industry/lunbo/4.webp'),
      }, {
        pic1: require('../../assets/image/Industry/lunbo/5.webp'),
        pic2: require('../../assets/image/Industry/lunbo/6.webp'),
      }]
    }
  },
  components: {
    titleCard
  },
  created() {

  },
  mounted() {

  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.kaineng {
  .title {
    padding: 1.0211rem 0 1.1368rem 0;
    @media screen and (max-width: 540px) {
      padding: 37px 0 45px 0;
    }
  }
  .head-cards {
    display: flex;
    justify-content: center;
    margin-bottom: 2.0632rem;
    @media screen and (max-width: 540px) {
      flex-wrap: wrap;
    }
    .card {
      width: 3.7684rem;
      cursor: pointer;
      @media screen and (max-width: 540px) {
        width: 45%;
        margin-bottom: 15px;
        height: 186px;
      }
      height: 3.9158rem;
      border: 1px solid #eaeaea;
      margin: 0 0.2737rem;
      //   display: flex;
      text-align: center;
      .card-img {
        width: 1.3684rem;
        height: 1.3684rem;
        margin: 0 auto;
        margin-top: 0.7789rem;
        border-radius: 0.6842rem;
        border: 0.0211rem solid #0ca6eb;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        @media screen and (max-width: 540px) {
          width: 65px;
          height: 65px;
          border-radius: 32.5px;
          margin-top: 37px;
        }
        .img {
          background: url('../../assets/image/Industry/kainengicon1.webp')
            no-repeat;
          background-size: cover;
          display: block;
          width: 0.6526rem;
          height: 0.6316rem;
          @media screen and (max-width: 540px) {
            width: 31px;
            height: 30px;
          }
        }
        .img2 {
          background: url('../../assets/image/Industry/kainengicon2.webp')
            no-repeat;
          background-size: cover;
          width: 0.7684rem;
          height: 0.6316rem;
          @media screen and (max-width: 540px) {
            width: 36px;
            height: 30px;
          }
        }
        .img3 {
          background: url('../../assets/image/Industry/kainengicon3.webp')
            no-repeat;
          background-size: cover;
          width: 0.5789rem;
          height: 0.6316rem;
          @media screen and (max-width: 540px) {
            width: 27px;
            height: 30px;
          }
        }
        .img4 {
          background: url('../../assets/image/Industry/kainengicon4.webp')
            no-repeat;
          background-size: cover;
          width: 0.6526rem;
          height: 0.6316rem;
          @media screen and (max-width: 540px) {
            width: 31px;
            height: 30px;
          }
        }
      }
      p {
        padding: 0.4421rem 0 0.1895rem 0;
        color: #333333;
        font-size: 0.2526rem;
        @media screen and (max-width: 540px) {
          font-size: 13px;
          padding-top: 25px;
        }
      }
      span {
        display: block;
        margin: 0 auto;
        background-color: #dadbdb;
        width: 0.4211rem;
        height: 0.0526rem;
        @media screen and (max-width: 540px) {
          width: 20px;
          height: 3px;
        }
      }
    }
    .card:hover {
      .card-img {
        background-color: #67cdfb;
      }
      p {
        color: #fff !important;
      }
      span {
        background-color: #fff !important;
      }
      background-color: #0ca6eb;
    }
  }
  .head-cards :nth-child(1):hover {
    .img {
      background: url('../../assets/image/Industry/kainengicon1-hover.webp')
        no-repeat;
      background-size: cover;
    }
  }
  .head-cards :nth-child(2):hover {
    .img {
      background: url('../../assets/image/Industry/kainengicon2-hover.webp')
        no-repeat;
      background-size: cover;
    }
  }
  .head-cards :nth-child(3):hover {
    .img {
      background: url('../../assets/image/Industry/kainengicon3-hover.webp')
        no-repeat;
      background-size: cover;
    }
  }
  .head-cards :nth-child(4):hover {
    .img {
      background: url('../../assets/image/Industry/kainengicon4-hover.webp')
        no-repeat;
      background-size: cover;
    }
  }
  // 公司简介
  .riref {
    padding: 0 1.7263rem;
    display: flex;
    margin-bottom: 0.8947rem;
    height: 6.1053rem;
    @media screen and (max-width: 540px) {
      display: block;
      height: 580px;
      padding: 0 15px;
    }
    .left {
      width: 7.0526rem;
      position: relative;
      @media screen and (max-width: 540px) {
        display: block;
        height: 280px;
        width: 100%;
      }
      .img1 {
        width: 100%;
        height: 5.2632rem;
        @media screen and (max-width: 540px) {
          height: 100%;
        }
      }
      .img2 {
        position: absolute;
        width: 3.5368rem;
        height: 2.6526rem;
        background: url('../../assets/image/Industry/kaineng2.webp') no-repeat;
        background-size: 100% 100%;
        background-color: #fff;
        left: 0;
        bottom: 0;
      }
    }
    .right {
      flex: 1;
      padding-left: 1.2632rem;
      position: relative;
      @media screen and (max-width: 540px) {
        padding: 0 5px;
      }
      .bg {
        position: absolute;
        width: 2.5789rem;
        height: 2.5789rem;
        right: 0;
        top: 0;
        background: url('../../assets/image/Industry/kaineng4.webp') no-repeat;
        background-size: 100% 100%;
        @media screen and (max-width: 540px) {
          width: 150px;
          height: 150px;
        }
      }
      .logo {
        width: 1.8526rem;
        height: 0.7895rem;
        padding-top: 0.7368rem;
        @media screen and (max-width: 540px) {
          padding-top: 36px;
          height: 45px;
          width: 106px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      h3 {
        margin: 0;
        padding: 0.2526rem 0 0.7368rem 0;
        color: #333333;
        font-size: 0.3158rem;
        @media screen and (max-width: 540px) {
          font-size: 18px;
          padding: 14px 0 21px 0;
        }
      }
      p {
        font-size: 0.2105rem;
        color: #666666;
        line-height: 0.3684rem;
        @media screen and (max-width: 540px) {
          display: none;
        }
      }
      .p {
        display: none;
        font-size: 15px;
        color: #666666;
        line-height: 26px;
        @media screen and (max-width: 540px) {
          display: block;
        }
      }
    }
  }
  // 背景
  .kaineng-bg {
    height: 2.2105rem;
    width: 100%;
    background: url('../../assets/image/Industry/kaineng-bg.webp') no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 540px) {
      height: 105px;
    }
    p {
      text-align: center;
      // padding: 0.6842rem 0;
      color: #ffffff;
      font-weight: 400;
      line-height: 0.5053rem;
      font-size: 0.3158rem;
      @media screen and (max-width: 540px) {
        font-size: 15px;
        line-height: 25px;
      }
    }
  }
  // 工厂实拍
  .gongchang {
    background-color: #fbfbfb;
    .title {
      padding: 1.2842rem 0 1.3684rem 0;
    }
    // 移动端轮播
    .lunboios {
      display: none;
      height: 160px;
      @media screen and (max-width: 540px) {
        display: block;
      }
      .el-carousel {
        height: 160px;
      }
      /deep/.el-carousel__container {
        height: 134px;
      }
      /deep/ .el-carousel__button {
        width: 15px;
        height: 5px;
        background-color: #c3c3c3;
      }
      /deep/ .el-carousel__indicator.is-active button {
        background-color: #0ca6eb;
      }
      /deep/ .el-carousel__indicator--horizontal {
        padding: 0 5px;
      }
      /deep/ .el-carousel__indicators--horizontal {
        bottom: 0.3158rem;
      }
      .el-carousel__item {
        overflow: hidden;
        .pic {
          float: left;
          width: 50%;
          height: 100%;
          box-sizing: border-box;
          padding: 10px;
          box-sizing: border-box;
          background-color: #ffffff;
          // margin: 0 0.1053rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .lunbo {
      height: 4.7368rem;
      @media screen and (max-width: 540px) {
        display: none;
      }
      .el-carousel {
        height: 4.7368rem;
      }
      /deep/.el-carousel__container {
        height: 3.8947rem;
      }
      /deep/ .el-carousel__button {
        height: 0.0842rem;
        width: 0.3158rem;
        background-color: #c3c3c3;
      }
      /deep/ .el-carousel__indicator.is-active button {
        background-color: #0ca6eb;
      }
      /deep/ .el-carousel__indicator--horizontal {
        padding: 0 0.0421rem;
      }
      /deep/ .el-carousel__indicators--horizontal {
        bottom: 0.3158rem;
      }
      .el-carousel__item {
        overflow: hidden;
        .pic {
          float: left;
          width: 6.1263rem;
          height: 3.8947rem;
          padding: 0.1053rem;
          box-sizing: border-box;
          background-color: #ffffff;
          margin: 0 0.1053rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .pic1 {
          margin-left: -3.1579rem;
        }
        .pic4 {
          margin-right: -3.1579rem;
        }
      }
    }
  }
  // 专利证书
  .zhuanli {
    background-color: #fff;
    .title {
      padding: 2.1053rem 0 1.3684rem 0;
    }
    .zhuanli-box {
      width: 60%;
      margin: 0 auto;
      @media screen and (max-width: 540px) {
        width: 100%;
        height: 220px;
      }
      height: 4.8632rem;
      padding-bottom: 1.8947rem;
      .el-carousel__item {
        text-align: center;
      }
      .el-carousel__item img {
        height: 99%;
        width: 50%;
        @media screen and (max-width: 540px) {
          width: 90%;
        }
      }
      // /deep/ .el-carousel__item--card {
      //   width: 2.6947rem;
      // }
      /deep/ .el-carousel__arrow {
        height: 0.5263rem;
        background-color: #ffffff8e;
        width: 0.5263rem;
        border: 0.0211rem solid #c6c6c6;
        color: #c6c6c6;
        font-size: 0.2737rem;
        @media screen and (max-width: 540px) {
          height: 25px;
          width: 25px;
        }
      }
      /deep/ .el-carousel--horizontal {
        padding: 0 50px;
      }
      /deep/ .el-carousel__arrow--left {
        left: -50px;
      }
      /deep/ .el-carousel__arrow--right {
        right: -50px;
      }
      /deep/ .el-carousel__container {
        height: 3.8105rem;
        @media screen and (max-width: 540px) {
          height: 200px;
          // width: 80%;
        }
      }
      /deep/ .el-carousel__item {
        left: -25px;
      }
      /deep/ .el-carousel__button {
        height: 0.0842rem;
        width: 0.3158rem;
        @media screen and (max-width: 540px) {
          width: 15px;
          height: 5px;
        }
        background-color: #c3c3c3;
      }
      /deep/ .el-carousel__indicator.is-active button {
        background-color: #0ca6eb;
      }
      /deep/ .el-carousel__indicator--horizontal {
        padding: 0 0.0421rem;
        @media screen and (max-width: 540px) {
          padding: 0 5px;
        }
        padding-top: 1.0526rem;
      }
    }
  }
}
</style>
